import { createActionCreator } from 'deox'
import { IPool, IPoolProps } from '../../types/reducerTypes'

export const addAllListPools = createActionCreator(
  'ADD_ALL_POOLS',
  (resolve) => (pools: IPoolProps[], total: number) => resolve({ pools, total }),
)

export const setAllPoolsStatusLoading = createActionCreator(
  'SET_ALL_POOLS_STATUS_LOADING',
  (resolve) => (loading: boolean) => resolve({ loading }),
)

type PoolTypes = 'labs' | 'launch'

export const addUpcomingListPools = createActionCreator(
  'ADD_UPCOMING_POOLS',
  (resolve) => (type: PoolTypes, pools: IPoolProps[]) =>
    resolve({ type, pools }),
)

export const addActiveListPools = createActionCreator(
  'ADD_ACTIVE_POOLS',
  (resolve) => (type: PoolTypes, pools: IPoolProps[]) =>
    resolve({ type, pools }),
)

export const addCompletedListPools = createActionCreator(
  'ADD_COMPLETED_POOLS',
  (resolve) => (type: PoolTypes, pools: IPoolProps[]) =>
    resolve({ type, pools }),
)

export const addMostTractionListPools = createActionCreator(
  'ADD_MOST_TRACTION_POOLS',
  (resolve) => (type: PoolTypes, pools: IPoolProps[]) =>
    resolve({ type, pools }),
)

export const addRecentlyLaunchedListPools = createActionCreator(
  'ADD_RECENTLY_LAUNCHED_POOLS',
  (resolve) => (type: PoolTypes, pools: IPoolProps[]) =>
    resolve({ type, pools }),
)

export const addClosingSoonListPools = createActionCreator(
  'ADD_CLOSING_SOON_POOLS',
  (resolve) => (type: PoolTypes, pools: IPoolProps[]) =>
    resolve({ type, pools }),
)

export const addMostFundedListPools = createActionCreator(
  'ADD_MOST_FUNDED_POOLS',
  (resolve) => (type: PoolTypes, pools: IPoolProps[]) =>
    resolve({ type, pools }),
)

export const setStatusLoading = createActionCreator(
  'SET_STATUS_LOADING',
  (resolve) => (type: PoolTypes, loading: boolean) =>
    resolve({ type, loading }),
)

export const setOldPoolsAddress = createActionCreator(
  'SET_OLD_POOLS_ADDRESS',
  (resolve) => (type: PoolTypes, oldPoolsAddress: IPoolProps[]) =>
    resolve({ type, oldPoolsAddress }),
)

export const setSerialisedPools = createActionCreator(
  'SET_SERIALISED_POOLS',
  (resolve) => (type: PoolTypes, serialisedPools: {}) =>
    resolve({ type, serialisedPools }),
)
